import { render, staticRenderFns } from "./RecordSetting.vue?vue&type=template&id=429978b3&"
import script from "./RecordSetting.vue?vue&type=script&lang=js&"
export * from "./RecordSetting.vue?vue&type=script&lang=js&"
import style0 from "./RecordSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports